/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import * as FORMAT from "react-day-picker/moment";
import { useHistory } from "react-router-dom";
import { ReassingnCompliance } from "../modals";
import { openlightbox } from "../../util/Functions";
import DayPickerInput from "react-day-picker/DayPickerInput";
import DataTable from "react-data-table-component";
import Checkbox from "@mui/material/Checkbox";

import "react-day-picker/lib/style.css";
import moment from "moment";
import "moment/locale/es";
import { Cancel, Edit, ExpandMore, NavigateBefore, NavigateNext, Save, SkipNext, SkipPrevious } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {theme, customStyles, customStyles3} from "../../util/TableStyles"
import ReassingnCLevel from "../modals/ReassignCLevel";
import { noDataComponent } from "../../util/DataObject"

const CLevelReport = (props) => {
	moment.locale("es");
	const history = useHistory();
	const [disabled, setDisabled] = useState(true);
	const [agent, setAgent] = useState('');
	const [total, setTotal] = useState(0);
	const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [pages, setPages] = useState(0);
	const [tabActive, setTabActive] = useState('');
	const [agents, setAgents] = useState([]);
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [initialDate, setInitialDate] = useState(new Date());
	const [endingDate, setEndingDate] = useState(new Date());
	const [selectedDates, setSelectedDates] = useState([]);
	const [initialDateEnd, setInitialDateEnd] = useState(new Date());
	const [configAgent, setConfigAgent] = useState([]);
	const [maxAssign, setMaxAssign] = useState(0);
    const [limit, setLimit] = useState(50);
	const [clear, setClear] = useState(false);
	const tabs = [
		{
			name: "VALIDATES",
			title: "Validados",
		},
		{
			name: "CUSTOMERS",
			title: "Validaciones pendientes",
		},
	];
	const [state, setState] = React.useState({});
	const [unassigned, setUnassigned] = useState(0);
	const [asignados, setAsignados] = useState(0);
	const [revisados, setRevisados] = useState(0);
	const [dayPicker] = useState([
		{ key: "Inicio", title: "Fecha de inicio" },
		{ key: "Fin", title: "Fecha de fin" },
	]);
	const quantity = [
		{ title: "Asignados: ", data: tabActive === "AGENTS" ? asignados : total },
		{ title: "No asignados: ", data: unassigned },
	];
	if(tabActive === "AGENTS"){
		quantity.unshift({ title: "Revisados: ", data: revisados })
	} else {
		quantity["title"] === "Revisados: " && quantity.shift()
	}

	useEffect(() => {
		init();
	}, [props.content]);

	const createInitialDate = (date) => {
		let initial = new Date(date);
		let timeZone = moment(initial.toJSON().substring(0, 10)).tz("America/Mexico_City").toJSON();
		setInitialDate(new Date(timeZone));
	};

	const createInitialDateEnd = (date) => {
		let initial = new Date(date);
		let timeZone = moment(initial.toJSON().substring(0, 10)).tz("America/Mexico_City").toJSON();
		setInitialDateEnd(new Date(timeZone));
	};

	const initEndsDates = (initDate, endDate) => {
		createInitialDate("2016-10-03");
		if (initDate) {
			setStartDate(new Date(initDate));
			createInitialDateEnd(new Date(initDate).toJSON().substring(0, 10));
		} else {
			createInitialDateEnd("2016-10-03");
			setStartDate(null);
		}

		if (endDate) {
		let endString = endDate.substring(0, 10);
			setEndDate(new Date(new Date(endString).getTime()));
		} else {
			setEndDate(null);
		}

		if (initDate && endDate) {
			let dates = [];
			let diffTime = new Date(new Date(endDate).getTime() - 1).getTime() - new Date(initDate).getTime();
			let diffDays = diffTime / (1000 * 3600 * 24);
			for (let i = 0; i < parseInt(diffDays.toString()) + 1; i++) {
				dates.push(new Date(new Date(initDate).getTime() + 1000 * 3600 * 24 * i));
			}
			setSelectedDates(dates);
		}
	};

	const init = () => {
		initEndsDates(props.content.startDate, props.content.endDate);
		setDisabled(true);
		if (props.content.type == 'history') {
			setTabActive('VALIDATES');
		}
		if (props.content.type == 'customers') {
			setTabActive('CUSTOMERS');
		}
		if (props.content.hasOwnProperty('customers')) {
            setData(JSON.parse(JSON.stringify(props.content.customers)));
        }
        if (props.content.hasOwnProperty('agents')) {
            setAgents(JSON.parse(JSON.stringify(props.content.agents)));
        }
        if (props.content.hasOwnProperty('agent')) {
            setAgent(props.content.agent);
        }

        if (props.content.hasOwnProperty('page')) {
            setPage(props.content.page);
        }

        if (props.content.hasOwnProperty('pages')) {
            setPages(props.content.pages);
        }

        if (props.content.hasOwnProperty('total')) {
            setTotal(props.content.total);
        }

        if (props.content.hasOwnProperty('limit')) {
            setLimit(props.content.limit);
        }
	};

	const changeTab = async (tab) => {
		if (tabActive == tab) {
			return;
		}
        if(tab == 'VALIDATES'){
			setClear(true);
            setAgent('');
            let data = {
                type: 'history',
                page: 1,
                limit: limit,
            }
            findCLevel(data);
        }
		if (tab == "CUSTOMERS") {
			setAgent('');
			setClear(false);
			let data = {
                type: 'customers',
                page: 1,
                limit: limit,
            }
            findCLevel(data);
		}
		
	};
	
	const findCLevel = async (data) => {
		props.changeLoader(true);
		let request = await API.service('cLevelReport', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === "OK") {
			props.changeWidgets(request.data.data.widget);
			//setTabActive('C-LEVEL');
		}
		props.changeLoader(false);
	}

	const findCustomerAssign = async (customer, pageCurrent) => {
		props.changeLoader(true);
		let req = {
			type: 'customers',
			page: pageCurrent,
			limit: limit,
			agent_uuid: customer ? customer : '',
		};
		await findCLevel(req);
		props.changeLoader(false);
	};

	const findHistory = async (customer, pageCurrent) => {
		props.changeLoader(true);
		let req = {
			type: 'history',
			page: pageCurrent,
			limit: limit,
			agent_uuid: customer ? customer : '',
		};
		await findCLevel(req);
		props.changeLoader(false);
	}

	const changeAgent = async (e) => {
		setAgent(e.target.value);
		if (tabActive == 'CUSTOMERS') {
			findCustomerAssign(e.target.value, 1);
		}

		if(tabActive == 'VALIDATES'){
			findHistory(e.target.value, 1);
		}
	};

	const test = (data) => {
		if(tabActive === "CUSTOMERS" && props.config.actions.indexOf("reassign") > -1){
			if (data.selectedCount > 0) {
				const s = [];
				for (let i = 0; i < data.selectedRows.length; i++) {
					s.push(data.selectedRows[i]);
				}
				setState(s);
				setDisabled(false);
			} else {
				setDisabled(true);
			}

		}
	};

	const openModal = (dataSelect) => {
		let contentModal = {
			title: "Reasignar Clientes",
			agents: agents,
			customers: dataSelect,
		};
		const as = <ReassingnCLevel
			pos={props.pos}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			contentModal={contentModal}
			reassign={reassign}
			key="cardCancelW"
		/>
		openlightbox(as);
	};

	const reassign = async (customers, agent_uuid, close) => {
		let t = close;
		props.changeLoader(true);
		let req = {
			agent_uuid: agent_uuid,
			customers: customers,
		};
		let request = await API.service("reassignCLevel", req, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === "OK") {
			t();
			findCustomerAssign('', 1);
		}
		props.changeLoader(false);
	};

	const changeDayInit = async (date) => {
		let dates = [];
		let data = {};
		if (agent) {
			data["agent_uuid"] = agent;
		}

		let initString = date.toJSON().substring(0, 10);
		let initial = new Date(initString);
		let timeZone = moment(initial.toJSON().substring(0, 10)).tz("America/Mexico_City").toJSON();
		data["startDate"] = timeZone;

		setStartDate(date);
		createInitialDateEnd(date.toJSON().substring(0, 10));
		if (endDate) {
			if (endDate.getTime() < date.getTime()) {
				setEndDate(null);
			} else {
				let diffTime = endDate.getTime() - date.getTime();
				let diffDays = diffTime / (1000 * 3600 * 24);
				for (let i = 0; i < parseInt(diffDays.toString()) + 1; i++) {
				dates.push(new Date(date.getTime() + 1000 * 3600 * 24 * i));
				}
				let end = new Date(endDate.getTime());
				let timeZoneEnd = moment(end.toJSON().substring(0, 10))
				.tz("America/Mexico_City")
				.toJSON();
				data["endDate"] = timeZoneEnd;
			}
		}
		setSelectedDates(dates);
		await requestReport(data);
	};


	let requestReport = async (data) => {
		if (tabActive == "AGENTS") {
			data["type"] = "agents";
		}
		props.changeLoader(true);
		let request = await API.service("complianceReport", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === "OK") {
			if (data["agent_uuid"]) {
				request.data.data.widget[0].content["oldAgents"] = agents;
			}
			props.changeWidgets(request.data.data.widget);
		}
		props.changeLoader(false);
	};

	const columnsAgents = [
		{ selector: (row) => row.name, name: "Nombre de agente", width:"19%", wrap: true, sortable: true, },
		{ selector: (row) => row.email, name: "Email", width:"19%", wrap: true, sortable: true },
		{ selector: (row) => row.totalAssigned, name: "No. Asignaciones", width:"16%", sortable: true },
		{ selector: (row) => row.totalRejected, name: "No. rechazos", width:"13%", sortable: true },
		{ selector: (row) => row.totalValidated, name: "No. validaciones", width:"15%", sortable: true },
		{ selector: (row) => row.totalInvalidated, name: "Solicitar documentos", width:"18%", sortable: true },
	];

	const columnsCustomer = [
		{ selector: (row) => row.customer?.name, name: "Nombre de cliente", width:"19%", wrap: true, sortable: true, },
		{ selector: (row) => row.customer?.email, name: "Email", width:"19%", wrap: true, sortable: true },
		{ selector: (row) => row.customer?.risk_level, name: "Nivel Riesgo", width: "13%", sortable: true },
		{ selector: (row) => row.agent?.name, name: "Agente", width:"19%", sortable: true },
		{ selector: (row) => row.adate ? moment(row.adate).format('LLL') : '', name: "Fecha asignación", sortable: true },
	];

	const columsCLevel = [
		{ selector: (row) => row.customer?.name, name: "Nombre de cliente", width:"19%", wrap: true, sortable: true, },
		{ selector: (row) => row.customer?.email, name: "Email", width:"19%", wrap: true, sortable: true },
		{ selector: (row) => row.customer?.risk_level, name: "Nivel Riesgo", width: "13%", sortable: true },
		{ selector: (row) => row.agent?.name, name: "Agente", width:"19%", sortable: true },
		{ selector: (row) => row.adate ? moment(row.adate).format('LLL') : '', name: "Fecha asignación", sortable: true }
	]

	
	const changeMaxAssign = (e) => {
		setMaxAssign(e.target.value);
	}

	const changeDayEnd = async (date) => {
		setEndDate(date);
		let dates = [];
		let data = {};
		if(agent){
			data['agent_uuid'] = agent;
		}
		let end = new Date((date.getTime())+(1000*3600*24));
		let timeZoneEnd = moment(end.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
		data['endDate'] = timeZoneEnd;
		if(startDate){
			let diffTime = date.getTime() - startDate.getTime();
			let diffDays = diffTime/(1000*3600*24);
			for(let i = 0; i<parseInt(diffDays.toString())+1; i++){
				dates.push(new Date(startDate.getTime()+((1000*3600*24)*i)));
			};
			let initString = startDate.toJSON().substring(0, 10);
			let initial = new Date(initString);
			let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
			data['startDate'] = timeZone;
		}

		setSelectedDates(dates);
		await requestReport(data);
	}

	const paginationComponentOptions = {
		rowsPerPageText: 'Registros por página',
		rangeSeparatorText: "de",
	};

	const handlePageChange = async (p) => {
        if(p == page){
            return;
        }
		props.changeLoader(true);
		let data = {
			type: tabActive == 'CUSTOMERS' ? 'customers' : 'history',
			page: p,
			limit: limit,
			agent_uuid: agent,
		};

		await findCLevel(data);
		props.changeLoader(false);
	};

	const changeTotal = async (e) => {
		props.changeLoader(true);
		let req = {
			type: tabActive == 'CUSTOMERS' ? 'customers' : 'history',
			page: 1,
			limit: e,
			agent_uuid: agent,
		};
		await findCLevel(req);
		props.changeLoader(false);
	}

	const selectedData = (row) => {
		console.log(row)
	}

	return <div className="size-12">
		<div className="card">
			<div className="form-row hdr_transaction">
				<div className="col-ico"><i className="ibon-card inb4"/></div>
				<h3 className="col-8 fix-elm-title-widget">Operación de C-Level</h3>
					
			</div>
			<div className="size-12 tabBox">
				<ul>
					{
						tabs.map((item, index) => {
							return <li key={`admin-tabs-${index}`} className={tabActive === item.name ? "active" : ''} onClick={changeTab.bind(this, item.name)}>
								{item.title}
							</li>
						})
					}
				</ul>
			</div>
			<div className="size-12" style={{ display: "flex", justifyContent: "space-between"}}>
				<div className={tabActive === "CUSTOMERS" ? "tableTools pnl-log-oper compliance_customer" : "tableTools pnl-log-oper"}>
					{
						tabActive === "AGENTS" &&
						<>
							<label>
								<DayPickerInput
									onDayChange={changeDayInit}
									placeholder='Inicio'
									format="DD-MM-YYYY"
									inputProps={{
										readOnly: true
									}}
									value={startDate}
									formatDate={FORMAT.default.formatDate}
									parseDate={FORMAT.default.parseDate}
									dayPickerProps={{
									months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
									//month: true,
									fixedWeeks: false,
									pagedNavigation: true,
									numberOfMonths: 1,
									disabledDays: {
										before: initialDate,
										after: endingDate,
									},
									selectedDays: selectedDates,
									}}
								/>
							</label>
							<label>
								<DayPickerInput
									onDayChange={changeDayEnd}
									placeholder='Fin'
									format="DD-MM-YYYY"
									inputProps={{
										readOnly: true
									}}
									value={endDate}
									formatDate={FORMAT.default.formatDate}
									parseDate={FORMAT.default.parseDate}
									dayPickerProps={{
										months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
										pagedNavigation: true,
										numberOfMonths: 1,
										disabledDays: {
											before: initialDateEnd,
											after: endingDate
										},
										selectedDays: selectedDates
									}}
								/>
							</label>
						</>
					}  
					<div>
						<select value={agent} onChange={changeAgent.bind(this)} style={{ minWidth: "190px" }}>
						<option value=''>Agente</option>
						{agents.map((item, iData) => {
							return (
							<option value={item.uuid} label={item.name} key={iData}>
								{item.name}
							</option>
							);
						})}
						</select>
					</div>
					{/*
						quantity.map((i) => {
							return (
							<div key={i.title}>
								<div className="neutral">- {i.title} {i.data}</div>
							</div>
							);
						})
					*/}
				</div>
				{
					(tabActive === "CUSTOMERS" && props.config.actions.indexOf("reassign") > -1) && 
					<div className="tableTools pnl-log-oper justify-end">
						<div className={disabled ? "disable bigButton padding-left desktop"  : "bigButton padding-left desktop"} >
							<button disabled={disabled} onClick={() => openModal(state)}>
								Reasignar
							</button>
						</div>
					</div>
				}
			</div>

			<div style={{ width: "100%", margin: "auto", maxHeight: '500px !important' }}>
				<ThemeProvider theme={theme}>
					<DataTable
						columns={tabActive === "CUSTOMERS" ? columnsCustomer : columsCLevel}
						data={data}
						customStyles={customStyles}
						selectableRows={tabActive === "CUSTOMERS" && props.config.actions.indexOf("reassign") > -1 ? true : false}
						onChangeRowsPerPage={changeTotal}
						selectableRowsComponent={Checkbox}
						pagination={true}
						paginationServer
						paginationPerPage={props.content.limit ? props.content.limit : 50}
						paginationRowsPerPageOptions={[10,20,30,40,50]}
						paginationDefaultPage={props.content.page}
						paginationComponentOptions={paginationComponentOptions}
						paginationTotalRows={total}
						onChangePage={handlePageChange}
						clearSelectedRows={clear}
						//selectableRowSelected={(row) => {return false}}
						//fixedHeader d
						//selectableRowSelected={selectedData.bind(this)}
						onSelectedRowsChange={test}
						noDataComponent={noDataComponent}
						//selectableRowsNoSelectAll={true}
						// onSelectedRowsChange={tabActive === "CUSTOMERS" && props.config.actions.indexOf("reassign") > -1 ? test : null} // No puede ser null
					/>
				</ThemeProvider>
			</div>
		</div>
    </div>
};

export default CLevelReport;